import { render } from "./AddAssociationForm.vue?vue&type=template&id=2b5f4f22&scoped=true"
import script from "./AddAssociationForm.vue?vue&type=script&lang=js"
export * from "./AddAssociationForm.vue?vue&type=script&lang=js"

import "./AddAssociationForm.vue?vue&type=style&index=0&id=2b5f4f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5f4f22"]])

export default __exports__